module.exports = __webpack_public_path__ + "static/graph-default-320967cf82a62c691f7abd14264adc8b.svg";